import AturBobot from "../../../../../components/categories/siakad/lms/leger/subpage/atur_bobot/Home";
export default function Home() {
  
  return (
    <AturBobot />
  );
}
